import React from "react"

import Footer from "../components/Common/Footer"
import ReviewSlider from "../components/Common/ReviewSlider"
import ContactDetails from "../components/core/ContactUsPage/ContactDetails"
import ContactForm from "../components/core/ContactUsPage/ContactForm"

const Contact = () => {
  return (
    <div className="bg-pure-greys-250">
      <div className="mx-auto mt-20 flex w-11/12 max-w-maxContent flex-col justify-between gap-10 text-white lg:flex-row bg-pure-greys-250">
        {/* Contact Details */}
        <div className="lg:w-[40%] ">
          <ContactDetails />
          <address id="address" className="mt-12 text-xl text-richblack-800">
           Course Catalyst 154/7 connaught place-delhi
          </address>
          <div className="mt-10 lg:w-[40%] ">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d448193.95106615534!2d76.76355477113817!3d28.644287345100643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd5b347eb62d%3A0x37205b715389640!2sDelhi!5e0!3m2!1sen!2sin!4v1708919974697!5m2!1sen!2sin" width="500" height="380"  allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>

        {/* Contact Form */}
        <div className="lg:w-[60%]">
          <ContactForm />
        </div>
      </div>
      <div className="relative mx-auto my-20 flex w-11/12 max-w-maxContent flex-col items-center justify-between gap-8 bg-pure-greys-150 text-white rounded-xl ">
        {/* Reviws from Other Learner */}
        <h1 className="text-center text-4xl font-semibold mt-8">
          Reviews from other learners
        </h1>
        <ReviewSlider />
      </div>
      <Footer />
    </div>
  )
}

export default Contact
